// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".category-filter{border-bottom:3px solid #fff}.category-filter:hover{border-bottom:3px solid #3e63f6;color:#3e63f6;font-weight:700;transition-duration:.7s}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
